import React, { useContext } from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import { AuthContext } from './context/AuthContext';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { ChatbotProvider } from './context/ChatbotContext';
import { SnackbarProvider } from './context/SnackbarContext';
import Chatbot from './components/Chatbot';

// 레이아웃 및 컴포넌트
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Register from './pages/Register';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Categories from './pages/Categories';
import Statuses from './pages/Statuses';
import Profile from './pages/Profile';
import NotFound from './pages/NotFound';
import Calendar from './pages/Calendar';

// 테마 정의
const theme = createTheme({
  palette: {
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  typography: {
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  },
});

// 보호된 라우트 컴포넌트
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);

  if (loading) {
    return <div>로딩 중...</div>;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return children;
};

// 챗봇이 보이는 레이아웃 컴포넌트
const LayoutWithChatbot = () => {
  const { isAuthenticated } = useContext(AuthContext);

  return (
    <>
      <Layout />
      {isAuthenticated && <Chatbot />}
    </>
  );
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <SnackbarProvider>
        <ChatbotProvider>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/" element={
              <ProtectedRoute>
                <LayoutWithChatbot />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="customers" element={<Customers />} />
              <Route path="customers/:id" element={<CustomerDetail />} />
              <Route path="categories" element={<Categories />} />
              <Route path="statuses" element={<Statuses />} />
              <Route path="profile" element={<Profile />} />
              <Route path="calendar" element={<Calendar />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </ChatbotProvider>
      </SnackbarProvider>
    </ThemeProvider>
  );
}

export default App; 